const reportUrls = {
    formOptions: {
        url: '/reports/actions/formOptions'
    },
    general: {
        url: '/reports/general'
    },
    govService: {
        url: '/reports/govService'
    },
    munService: {
        url: '/reports/munService'
    },
    statsSecretary: {
        url: '/reports/statsSecretary'
    },
    nrk: {
        url: '/reports/nrk'
    },
    openClosed: {
        url: '/reports/openClosed'
    },
    questionData: {
        url: '/reports/questionData'
    },
    total: {
        url: '/reports/total'
    },
    rrk: {
        url: '/reports/rrk'
    }

};

export default reportUrls;
